import React, { useEffect, useState } from 'react';
import { Star } from 'lucide-react';
import { fetchCollection } from '../lib/cms';

export default function ReviewSlider() {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadReviews() {
      const data = await fetchCollection('anmeldelser');
      setReviews(data);
      setLoading(false);
    }
    loadReviews();
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center py-12">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-emerald-700"></div>
      </div>
    );
  }

  if (reviews.length === 0) {
    return null;
  }

  // Duplicate reviews to create a seamless infinite scroll effect
  const duplicatedReviews = [...reviews, ...reviews, ...reviews];

  return (
    <div className="relative w-full overflow-hidden py-10 bg-stone-50/50 rounded-2xl border border-stone-200/60">
      {/* Inline styles for the infinite marquee animation */}
      <style>{`
        @keyframes marquee {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-33.3333%);
          }
        }
        .animate-marquee {
          display: flex;
          width: max-content;
          animation: marquee 40s linear infinite;
        }
        .animate-marquee:hover {
          animation-play-state: paused;
        }
      `}</style>

      {/* Gradient Fades on the edges for premium look */}
      <div className="absolute left-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-r from-stone-50 to-transparent z-10 pointer-events-none" />
      <div className="absolute right-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-l from-stone-50 to-transparent z-10 pointer-events-none" />

      {/* Marquee Container */}
      <div className="animate-marquee gap-6 px-6">
        {duplicatedReviews.map((review, idx) => (
          <div
            key={`${review.id}-${idx}`}
            className="w-[280px] sm:w-[350px] md:w-[400px] shrink-0 bg-white p-6 md:p-8 rounded-xl border border-stone-200 shadow-sm flex flex-col justify-between transition-all duration-300 hover:shadow-md hover:border-emerald-200"
          >
            <div>
              {/* Stars */}
              <div className="flex items-center gap-1 mb-4">
                {[...Array(review.rating || 5)].map((_, i) => (
                  <Star key={i} className="w-4.5 h-4.5 fill-amber-400 text-amber-400" />
                ))}
              </div>
              {/* Text */}
              <p className="text-stone-700 text-sm md:text-base italic leading-relaxed mb-6">
                "{review.text?.da || review.text}"
              </p>
            </div>
            {/* Author */}
            <div className="border-t border-stone-100 pt-4 mt-auto">
              <h4 className="font-semibold text-stone-900 text-sm md:text-base">
                {review.author}
              </h4>
              <p className="text-emerald-700 text-xs md:text-sm font-medium mt-0.5">
                {review.role?.da || review.role}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
